import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useHotel } from '../context/HotelContext';
import { HOTELS_IMAGE_ROOT_URL } from '../constant';

const HomeScreen = () => {
    let [searchParams] = useSearchParams();
    const outletID = searchParams.get('outletID');
    const { hotelDetails } = useHotel();
    const navigate = useNavigate();

    const continueClickHandler = (route) => {
        let params = '';
        if (route === 'guest-details') params += `?outletID=${outletID}`;
        navigate(`/${route}${params}`);
    };

    return (
        <div className='outlet-screen bg-img min-h-dvh flex flex-col justify-start items-center px-4'>
            <div className='head-section w-full z-10 flex justify-center items-center flex-row  py-3 relative md:justify-center md:flex-col md:py-5'>
                <div
                    className='back-btn absolute '
                    onClick={() => navigate(-1)}
                ></div>
                {hotelDetails.logo && (
                    <img
                        src={`${HOTELS_IMAGE_ROOT_URL}${hotelDetails.logo}`}
                        alt='logo'
                        className='max-w-32 md:max-w-60'
                        onClick={() => navigate('/', { replace: true })}
                    />
                )}
            </div>
            <div className='choice-container w-full flex flex-col gap-12  justify-center items-center md:gap-16'>
                <div
                    className=' flex justify-center items-center choice-card'
                    onClick={() => continueClickHandler('guest-details')}
                >
                    <div className='icon  icon-guest'></div>
                    <div className='choice-card-text flex justify-center items-center'>
                        Collect Guest Details
                    </div>
                </div>
                <div
                    className=' flex justify-center items-center choice-card '
                    onClick={() => continueClickHandler('contact-list')}
                >
                    <div className='icon  icon-contact'></div>
                    <div className='choice-card-text flex justify-center items-center'>
                        View Contact Book
                    </div>
                </div>
                <div
                    className=' flex justify-center items-center choice-card'
                    onClick={() => continueClickHandler('visitor-history')}
                >
                    <div className='icon   icon-history'></div>
                    <div className='choice-card-text flex justify-center items-center'>
                        View Visitors History
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeScreen;
